import React from 'react'

const Job = ({ job = {}}) => {
    return (
        <div className="flex justify-between items-center">
            <div className="flex justify-start items-center">
                <div className="text-lg">
                    { job.title }
                </div>
            </div>
        </div>
    );
}

export default Job;